exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ScanInfoModal-module__modalContent2___3o1MK .ScanInfoModal-module__image-wrapper___F5H18{max-width:500px;display:flex;justify-content:center;margin:0 auto 40px}.ScanInfoModal-module__modalContent2___3o1MK .ScanInfoModal-module__image-wrapper___F5H18 img{width:400px;margin-left:100%;margin-right:100%}.ScanInfoModal-module__modalContent2___3o1MK h1,.ScanInfoModal-module__modalContent2___3o1MK p{margin-bottom:25px;padding-left:10px}.ScanInfoModal-module__modalContent2___3o1MK .ScanInfoModal-module__buttons-wrapper___1GUvq{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:center}", ""]);

// exports
exports.locals = {
	"modalContent2": "ScanInfoModal-module__modalContent2___3o1MK",
	"image-wrapper": "ScanInfoModal-module__image-wrapper___F5H18",
	"buttons-wrapper": "ScanInfoModal-module__buttons-wrapper___1GUvq"
};